import React, { PropsWithChildren } from 'react'
import stanchions from '../../icon/closed-background.svg'
import "../../css/BobbingIcon.css"

function ClosedGraphic(props: PropsWithChildren<any>) {
  return (
    <div className="frillsContainer" style={{ zIndex: 10 }}>
      <div className="closedSignContainer">
        {props.children}
      </div>
      <img src={stanchions} alt="" />
    </div>
  )
}

export default ClosedGraphic
